import { typeofbacteria_bwccore } from './pdfScoreConfig_bwccore.js';

// Mapping from full names to abbreviated names
const bacteriaNameMapping_core = {
    // Core bacteria
    'Akkermansia muciniphila': 'A. muciniphila',
    'Alistipes putredinis': 'A. putredinis',
    'Bacteroidetes phylum': 'Bacteroidetes phylum',
    'Bacteroides fragilis': 'B. fragilis',
    'Clostridium cluster IV': 'C. cluster IV',
    'Enterococcus genus': 'Enterococcus genus',
    'Faecalibacterium prausnitzii': 'F. prausnitzii',
    'Roseburia hominis': 'R. hominis',
    'Ruminococcus genus': 'Ruminococcus spp.',
    
    // Beneficial bacteria
    'Bifidobacterium bifidum': 'B. bifidum',
    'Bifidobacterium breve': 'B. breve',
    'Bifidobacterium lactis': 'B. lactis',
    'Bifidobacterium longum': 'B. longum',
    'Lactobacillus acidophilus': 'L. acidophilus',
    'Lactobacillus gasseri': 'L. gasseri',
    'Lactobacillus helveticus': 'L. helveticus',
    'Lactobacillus paracasei': 'L. paracasei',
    'Lactobacillus plantarum': 'L. plantarum',
    'Lactobacillus reuteri': 'L. reuteri',
    'Lactobacillus rhamnosus': 'L. rhamnosus',
    'Streptococcus thermophilus': 'S. thermophilus',
    
    // Harmful bacteria
    'Bacillus genus': 'Bacillus genus',
    'Candida albicans': 'C. albicans',
    'Clostridium difficile': 'C. difficile',
    'Escherichia coli': 'E. coli',
    'Staphylococcus aureus': 'S. aureus',
};

// Configuration for displaying beneficial bacteria names when they are deficient or slightly deficient
export const pdfTextPreciseConfig_bwccore = {
    // Configuration for beneficial bacteria deficiency display
    beneficial_bacteria_deficiency: [
        {
            page: 7,
            version: 'eng',
            Xpostext: 83,
            Ypostext: 403,
            fontsize: 10,
            maxWidth: 240,
            condition: 'beneficial_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 7,
            version: 'eng',
            Xpostext: 290,
            Ypostext: 221,
            fontsize: 10,
            maxWidth: 210,
            condition: 'core_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 6,
            version: 'thai',
            Xpostext: 83,
            Ypostext: 407,
            fontsize: 10,
            maxWidth: 240,
            condition: 'beneficial_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 6,
            version: 'thai',
            Xpostext: 290,
            Ypostext: 223,
            fontsize: 10,
            maxWidth: 230,
            condition: 'core_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
    ]
};

// Helper function to get deficient beneficial bacteria names
export const getDeficientBacteriaNames = (bacteriaResults, bacteriaType = 'beneficial_bacteria', targetLabels = ['Deficient', 'Slightly Deficient']) => {
    const bacteriaList = typeofbacteria_bwccore[bacteriaType] || [];
    const deficientBacteria = [];

    bacteriaList.forEach(bacteriaName => {
        const result = bacteriaResults[bacteriaName];
        if (result && targetLabels.includes(result.label)) {
            deficientBacteria.push(bacteriaName);
        }
    });

    return deficientBacteria;
};

// Helper function to format bacteria names for display with abbreviation mapping
export const formatBacteriaNames = (bacteriaNames) => {
    if (bacteriaNames.length === 0) {
        return 'None';
    }
    
    // Map full names to abbreviated names
    const abbreviatedNames = bacteriaNames.map(name => bacteriaNameMapping_core[name] || name);
    return abbreviatedNames.join(', ');
};

// Helper function to get configuration for specific page and language
export const getTextConfigForPage = (pageNumber, language = 'eng') => {
    const configs = pdfTextPreciseConfig_bwccore.beneficial_bacteria_deficiency;
    return configs.find(config => config.page === pageNumber && config.version === language);
};
